import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskRevoke = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskRevoke;
